import { DeviceStatusBar } from './DeviceStatusBar';

export interface IDisplayMetrics {
    screen: { width: number; height: number; }
    viewport: { width: number; height: number; }
    devicePixelRatio: number;
    // optional: only available once DeviceStatusBar.init() has run (see getMetrics)
    statusBarHeight?: number;
    navigationBarHeight?: number;
}

/**
 * Provides display metrics for tracking and analytics.
 * Computes metrics on-demand to capture current viewport state
 * (e.g., if app is resized or rotated).
 */
export class DisplayMetricsProvider {
    static inject = () => [DeviceStatusBar];

    constructor(private statusBar: DeviceStatusBar){}

    getMetrics = (): IDisplayMetrics => {
        const metrics: IDisplayMetrics = {
            screen: {
                width: window.screen.width,
                height: window.screen.height,
            },
            viewport: {
                width: window.innerWidth,
                height: window.innerHeight
            },
            devicePixelRatio: window.devicePixelRatio
        };

        // The status/nav bar heights require DeviceStatusBar.init() to have run. Tracking can
        // fire before that (e.g. during a failed app start, where DeviceStatusBar.init is never
        // reached), so omit these rather than letting the getters throw — the window metrics
        // above need no init and are always available, so the event can still be sent.
        if (this.statusBar.isInitialized()) {
            metrics.statusBarHeight = this.statusBar.getHeight();
            metrics.navigationBarHeight = this.statusBar.getNavigationBarHeight();
        }

        return metrics;
    };

}
